module.exports = __webpack_public_path__ + "static/media/videoBadgeLevel3Locked.79aae711.png";